import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Actions
import * as ReportActions from 'store/ducks/reports/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import CONST_HISTORY from 'constants/historyFilter';

// Styles
import useStyles from './historyFilter.styles';

const HistoryFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedHistory = useSelector(
    (state: ApplicationState) => state.reports.history,
  );

  const handleStatus = (value: boolean) => {
    dispatch(
      ReportActions.setHistoryFilter({
        history: value,
      }),
    );
  };

  return (
    <List dense>
      {CONST_HISTORY.TYPE.map((item) => (
        <ListItem key={item.LABEL} button>
          <ListItemText
            id={item.LABEL}
            primary={item.LABEL}
            onClick={() => handleStatus(item.VALUE)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Radio
              edge='end'
              name={item.LABEL}
              color='primary'
              onClick={() => handleStatus(item.VALUE)}
              checked={selectedHistory === item.VALUE}
              inputProps={{ 'aria-labelledby': item.LABEL }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { HistoryFilter };
export default HistoryFilter;
